<h1 mat-dialog-title>{{'Edit user data' | translate}}</h1>
<div mat-dialog-content>
    <form [formGroup]="form">
        <mat-form-field appearance="fill">
            <mat-label>{{'Phone' | translate}}</mat-label>
            <input type="text" matInput [formControl]="phone">
            <mat-error *ngIf="phone.hasError('required')">
                <strong>{{'Required' | translate}}</strong>
            </mat-error>
        </mat-form-field>
        <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>{{'Email' | translate}}</mat-label>
            <input type="email" matInput [formControl]="email" [errorStateMatcher]="matcher"
                placeholder="mail@example.com">
            <mat-error *ngIf="email.hasError('email') && !email.hasError('required')">
                {{'Please enter a valid email address' | translate}}
            </mat-error>
            <mat-error *ngIf="email.hasError('required')">
                <strong>{{'Required' | translate}}</strong>
            </mat-error>
        </mat-form-field>

        <p>
            <mat-checkbox class="example-margin" [formControl]="is_active">{{'Is active' | translate}}</mat-checkbox>
        </p>
        <p>
            <mat-checkbox class="example-margin" [formControl]="blocked">{{'Is blocked' | translate}}</mat-checkbox>
        </p>

        <mat-form-field appearance="fill">
            <mat-label>{{'Name' | translate}}</mat-label>
            <input type="text" matInput [formControl]="name">
            <mat-error *ngIf="name.hasError('required')">
                <strong>{{'Required' | translate}}</strong>
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>{{'Company name' | translate}}</mat-label>
            <input type="text" matInput [formControl]="company_name">
            <mat-error *ngIf="company_name.hasError('required')">
                <strong>{{'Required' | translate}}</strong>
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>{{'Area' | translate}}</mat-label>
            <input type="text" matInput [formControl]="area">
            <mat-error *ngIf="area.hasError('required')">
                <strong>{{'Required' | translate}}</strong>
            </mat-error>
        </mat-form-field>
    </form>
</div>

<div mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
        {{'Close' | translate}}
    </button>
    <button mat-raised-button color="primary" (click)="submit()" [disabled]="form.invalid">
        {{'Update' | translate}}
    </button>
</div>
